import React, { useMemo, useState } from 'react';
import { Container } from 'react-bootstrap';
import ReportsTable from '../../../components/tables/ReportsTable';

const serviceTypes = [
  'Recharge',
  'Bill Payment',
  'AEPS',
  'BBPS',
  'Payout',
  'DMT',
  'Micro ATM'
];

const txnStatuses = ['Successful', 'Pending', 'Failed', 'Reversed'];

const generateMasterDistributorTxnData = (count = 100) => {
  return Array.from({ length: count }, (_, index) => {
    const txnDate = new Date(
      2025,
      Math.floor(Math.random() * 12),
      Math.floor(Math.random() * 28) + 1,
      Math.floor(Math.random() * 24),
      Math.floor(Math.random() * 60)
    );

    const amount = parseFloat((Math.random() * 125000 + 5000).toFixed(2));
    const charge = parseFloat((amount * 0.0035).toFixed(2));
    const commission = parseFloat((amount * 0.014).toFixed(2));

    return {
      txnId: `MDTXN${String(index + 1).padStart(6, '0')}`,
      date: txnDate.toISOString().split('T')[0],
      time: txnDate.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' }),
      masterDistributorCode: `MD${String(Math.floor(Math.random() * 9000) + 1000)}`,
      masterDistributorName: `Master Distributor ${Math.floor(Math.random() * 120) + 1}`,
      service: serviceTypes[Math.floor(Math.random() * serviceTypes.length)],
      amount,
      charge,
      commission,
      status: txnStatuses[Math.floor(Math.random() * txnStatuses.length)],
      rrn: Math.random().toString(36).substring(2, 10).toUpperCase(),
      referenceId: `REF${Math.random().toString(36).substring(2, 10).toUpperCase()}`
    };
  });
};

const formatCurrency = (value) =>
  `₹${Number(value || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`;

const ReportsMasterDistributorTransactions = () => {
  const [transactions] = useState(() => generateMasterDistributorTxnData(140));

  const columns = useMemo(
    () => [
      { key: 'txnId', label: 'Txn ID' },
      { key: 'date', label: 'Date' },
      { key: 'time', label: 'Time' },
      { key: 'masterDistributorCode', label: 'Master Distributor Code' },
      { key: 'masterDistributorName', label: 'Master Distributor Name' },
      { key: 'service', label: 'Service' },
      {
        key: 'amount',
        label: 'Amount (₹)',
        render: (_, value) => formatCurrency(value)
      },
      {
        key: 'charge',
        label: 'Charge (₹)',
        render: (_, value) => formatCurrency(value)
      },
      {
        key: 'commission',
        label: 'Commission (₹)',
        render: (_, value) => formatCurrency(value)
      },
      {
        key: 'status',
        label: 'Status',
        render: (row) => {
          const variant =
            row.status === 'Successful'
              ? 'success'
              : row.status === 'Pending'
              ? 'warning'
              : row.status === 'Failed'
              ? 'danger'
              : 'secondary';

          return <span className={`badge bg-${variant}`}>{row.status}</span>;
        }
      },
      { key: 'rrn', label: 'RRN' },
      { key: 'referenceId', label: 'Reference ID' }
    ],
    []
  );

  return (
    <Container fluid>
      <ReportsTable
        data={transactions}
        reportType='SuperDistributor_MasterDistributorTransactions'
        columns={columns}
        title='Master Distributor Transaction Report'
        cellPaddingY={8}
      />
    </Container>
  );
};

export default ReportsMasterDistributorTransactions;


